import { EventEmitter, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
//import moment from "moment";
import { DateTime } from 'luxon';

@Injectable({
    providedIn: "root"
})
export class TranslationService {
   
    private _currentLanguage = "en";

    public onLangChange: EventEmitter<any>

    constructor(
        private translate: TranslateService,
    ) {
        this.onLangChange = new EventEmitter<any>()
    }

    get currentLanguage(): string {
        return this._currentLanguage;
    }

    useLanguage(selectedLanguage: string) {
        this._currentLanguage = selectedLanguage;

        this.translate.use(selectedLanguage).subscribe(x => {
            this.onLangChange.emit(x);
        });
    }

    /*
    whichTranslation(cutDt, evalDt, before: string, after: string) {
        const cutDtm = cutDt.toISOString ? cutDt : moment(cutDt, "MM/DD/YYYY");
        const evalDtm = evalDt.toISOString ? evalDt : moment(evalDt, "MM/DD/YYYY");

        return evalDtm < cutDtm ? before : after;
    }
    */

    
    whichTranslation(cutDt, evalDt, before: string, after: string) {
        const cutDtm = this.toLuxon(cutDt);
        const evalDtm = this.toLuxon(evalDt);

        if (!cutDtm || !evalDtm) {
            return before;
        }

        return evalDtm < cutDtm ? before : after;
    }

    toLuxon(dt: Date | DateTime | string | null): DateTime | null {
        if (!dt) {
            return null;
        }

        if (dt instanceof DateTime) {
            return dt;
        }

        if (dt instanceof Date) {
            return DateTime.fromJSDate(dt);
        }

        return DateTime.fromFormat(dt, "MM/dd/yyyy");
    }
    
}
